import { TaskStatus } from '../../../models';

export const tasksTabs = [
  { name: 'Current', link: 'current', status: TaskStatus.InProgress },
  { name: 'Completed', link: 'completed', status: TaskStatus.Completed },
  { name: 'Late', link: 'late' },
  //  TODO: reuse after implementation
  // { name: 'Canceled', link: 'canceled' },
  { name: 'All', link: 'all' },
];
